import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/offer';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-48" data-mp="1ntzwr5frfkzq">
      <Reveal className="mx-auto max-w-3xl" data-id="element-49" data-mp="1nwmdnvojjcum">
        <div className="mb-12 text-center" data-id="element-50" data-mp="2blf2z9anqmg9">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-51" data-mp="2bmgoy8t7otcr">BUENO SABERLO</p>
          <h2 className="text-3xl font-black text-brand-deep md:text-4xl" data-id="element-52" data-mp="2fns8pxpemkd1">Preguntas frecuentes</h2>
        </div>
        <div className="space-y-3" data-id="element-53" data-mp="26tnldo9hbr29">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="overflow-hidden rounded-2xl border border-brand-deep/[0.06] bg-brand-alt" data-id="element-54" data-mp="2z9omg4keey48" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-bold text-brand-deep focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-amber" data-id="element-55" data-mp="1vqsyy291z5lj">
                  <span data-id="element-56" data-mp="2ffl89qsf9vy0">{question}</span>
                  {open ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-green" aria-hidden="true" data-id="element-57" data-mp="2ae5lnualjhdi" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-green" aria-hidden="true" data-id="element-58" data-mp="2occaym1hc91k" />}
                </button>
                <AnimatePresence initial={false} data-id="element-59" data-mp="tzw1lcde0esh">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-60" data-mp="p1ko8rnvvm5i">
                      <p className="px-6 pb-6 leading-relaxed text-brand-gray" data-id="element-61" data-mp="2z44cm38lb257">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}